import apiClient from '../../../common/services/apiClient';
import { createQueryString, removeFalsyProperties } from '../../../common/utils/helpers';

export const apiCallIds = {
  FETCH_MESSAGING_DATA: 'FETCH_MESSAGING_DATA',
  FETCH_EMAIL_LOGS: 'FETCH_EMAIL_LOGS',
  FETCH_SMS_LOGS: 'FETCH_SMS_LOGS',
  FETCH_EMAIL_LOG: 'FETCH_EMAIL_LOG',
  FETCH_HOLIDAYS: 'FETCH_HOLIDAYS',
  ADD_HOLIDAY: 'ADD_HOLIDAY',
  DELETE_HOLIDAY: 'DELETE_HOLIDAY'

};

export default {
  fetchMessagingData: () => {
    return apiClient.get(`/messaging/report`);
  },

  fetchEmailLogs: options => {
    return apiClient.get(`/messaging/emails?${createQueryString(options)}`);
  },
  fetchSmsLogs: options => {
    return apiClient.get(`/messaging/sms?${createQueryString(options)}`);
  },
  fetchEmailLog: loanId => {
    return apiClient.get(`/messaging/emails/${loanId}`);
  },
  fetchHolidays: options => {
    return apiClient.get(`/messaging/holidays?${createQueryString(options)}`);

  },
  addHoliday: holidayData => {
    return apiClient.post(`/messaging/holidays/add`, holidayData, {
      apiCallId: apiCallIds.ADD_HOLIDAY
    });

  },

  deleteHoliday: holidayId => {
    return apiClient.delete(`/messaging/holidays/delete/${holidayId}`, {
      apiCallId: apiCallIds.DELETE_HOLIDAY
    });

  },

};



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/api/index.js